import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { EmrConsentSkipButton } from './EmrConsentSkipButton'

export const MedicalReleaseSignatureButtonGroup = (
  props: ApplySuccessPageProps,
) => {
  return (
    <div className='z-10 mx-8 flex w-full flex-row justify-end gap-2'>
      <EmrConsentSkipButton className='w-1/3' {...props} />
      <Button
        className={classMerge(
          buttonClassNames.legacy.fill.black,
          'pointer-events-auto w-full rounded-full md:w-60',
        )}
        onClick={() =>
          trackEvent(TrackingEvents.EMR_RELEASE_SIGNATURE_SUBMITTED)
        }
        type='submit'
      >
        Accept and sign <Icon className='ml-2' icon={faArrowRight} />
      </Button>
    </div>
  )
}
